import { FC, useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';

import {
  clearMetricsSession,
  fetchMonitoringSession,
  getMetricsSession,
  setMonitoringUnauthorizedHandler,
} from 'src/apis/monitoring';
import AuthLayout from 'src/containers/auth/AuthLayout';
import { useCommonStyles } from 'src/containers/onboarding-redesign/utils/useCommonStyles';

import MetricsDashboard from './MetricsDashboard';
import MetricsPasswordGate from './MetricsPasswordGate';

type MetricsAuthStatus = 'checking' | 'locked' | 'unlocked';

const MetricsSessionCheck: FC = () => {
  const commonStyles = useCommonStyles();

  return (
    <AuthLayout>
      <Typography className={commonStyles.headline1}>Metrics</Typography>
      <Typography className={commonStyles.body1}>Checking access…</Typography>
    </AuthLayout>
  );
};

const MetricsScreen: FC = () => {
  const [status, setStatus] = useState<MetricsAuthStatus>('checking');

  useEffect(() => {
    setMonitoringUnauthorizedHandler(() => setStatus('locked'));

    const session = getMetricsSession();
    if (!session) {
      setStatus('locked');
      return () => setMonitoringUnauthorizedHandler(null);
    }

    fetchMonitoringSession()
      .then((data) => {
        if (data.valid) {
          setStatus('unlocked');
          return;
        }

        clearMetricsSession();
        setStatus('locked');
      })
      .catch(() => {
        setStatus('locked');
      });

    return () => setMonitoringUnauthorizedHandler(null);
  }, []);

  if (status === 'checking') {
    return <MetricsSessionCheck />;
  }

  if (status === 'locked') {
    return <MetricsPasswordGate onUnlock={() => setStatus('unlocked')} />;
  }

  return <MetricsDashboard />;
};

export default MetricsScreen;
